import Link from "next/link";
import { LinkText } from "./styles.ts";

export type TLink = {
  name: string;
  title: string;
  url: string;
  target?: string;
};

export interface ILinkGroupProps {
  links: TLink[];
}

export const LinkGroup = ({ links }: ILinkGroupProps) => (
  <ul>
    {links?.map((link) => (
      <li
        style={{ lineHeight: "28px", fontSize: "14px" }}
        key={link.name}
      >
        <Link
          href={link.url || ""}
          target={link.target}
          title={`Link to ${link.name}`}
        >
          <LinkText>{link.name}</LinkText>
        </Link>
      </li>
    ))}
  </ul>
);
